<template>
  <div
    class="content-devx transparent headers-initial"
    style="padding: 1rem 0 !important;"
  >
    <div
      :class="`${showScroll ? 'scrollview-oa' : ''}`"
      style="display: flex; justify-content: center !important; align-items: center; width: auto"
    >
      <DxScrollView
        :scroll-by-content="showScroll"
        :scroll-by-thumb="showScroll"
        direction="both"
      >
        <DxDataGrid
          :data-source="data"
          :allow-column-resazing="true"
          :allow-column-reordering="true"
          :show-borders="true"
          :show-column-lines="true"
          :show-row-lines="false"
          :column-auto-width="true"
          :row-alternation-enabled="false"
          :word-wrap-enabled="true"
          no-data-text="Sin datos"
          @file-saving="onFileSaving"
        >
          <DxSelection
            mode="single"
          />
          <DxExport
            :enabled="true"
            :file-name="`${resultProject.name} - Abonado - RECOMENDACIONES`"
          />
          <DxPaging
            :enabled="false"
            :page-size="10"
          />
          <DxPager
            :visible="false"
            :show-page-size-selector="true"
            :show-info="true"
            info-text="Página {0} de {1} ({2} semanas)"
            :allowed-page-sizes="['5', '10', '20', '30', '60']"
          />
          <DxHeaderFilter :visible="true" />
          <DxSearchPanel
            text=""
            :visible="true"
            :width="200"
            :placeholder="$t('Search_placeholder')"
          />
          <DxColumnFixing :enabled="DEVICE_PLATFORM === 'android'" />
          <DxColumn
            data-field="date"
            :caption="$t('result.fertigation.date')"
            :allow-header-filtering="false"
            alignment="left"
            css-class="column-center break-word-column"
            :allow-resizing="true"
            :fixed="DEVICE_PLATFORM === 'android' && showColumnByCrop"
            fixed-position="left"
          />
          <DxColumn
            data-field="week"
            :caption="$t('result.manure.week')"
            :allow-header-filtering="false"
            alignment="left"
          />
          <DxColumn
            :data-field="'soil_needs_N'"
            :caption="`N (kg/ha)`"
            :allow-header-filtering="false"
            alignment="left"
            :min-width="85"
          />
          <DxColumn
            v-if="showColumnByCrop"
            :data-field="'soil_needs_P'"
            :caption="`P (kg/ha)`"
            :allow-header-filtering="false"
            alignment="left"
            :min-width="85"
          />
          <DxColumn
            v-if="showColumnByCrop"
            :data-field="'soil_needs_K'"
            :caption="`K (kg/ha)`"
            :allow-header-filtering="false"
            alignment="left"
            :min-width="85"
          />
          <DxColumn
            v-if="showColumnByCrop"
            :data-field="'soil_needs_Ca'"
            :caption="`Ca (kg/ha)`"
            :allow-header-filtering="false"
            alignment="left"
            :min-width="85"
          />
          <DxColumn
            v-if="showColumnByCrop"
            :data-field="'soil_needs_Mg'"
            :caption="`Mg (kg/ha)`"
            :allow-header-filtering="false"
            alignment="left"
            :min-width="85"
          />
        </DxDataGrid>
      </DxScrollView>
    </div>
    <div
      class="content-note"
      style="margin-top: 1rem; max-width: 100%;"
    >
      <span class="note">
        En los cultivos sandía, calabacín y berenjena solo se ofrecen resultados de riego y N
      </span>
    </div>
    <div
      class="controls-pane"
      style="margin-top: 1rem; margin-bottom: 1rem;"
    >
      <DxButton
        id="export"
        style="background-color: #616B7C; padding: 0.5rem;"
        type="default"
        :text="$t('showAll')"
        @click="showAll()"
      />
    </div>
    <f7-block-footer
      class="content-action-botton"
    >
      <f7-link
        popover-open=".popover-menu"
        data-popover=".links-popover"
        class="dx-btn-success dx-btn-see-more sm-popover"
      >
        {{ $t('seeMore') }}
      </f7-link>
      <f7-popover class="popover-menu links-popover">
        <f7-list>
          <f7-list-item
            link="/manureResult/detailManure/"
            popover-close
            :title="$t('result.manure.seasonal_recommendation_nutrient_concentration')"
          />
        </f7-list>
      </f7-popover>
      <f7-button
        class="dx-btn-cancel color-GreenHouse"
        raised
        type="default"
        styling-mode="outlined"
        name="ButtonCancel"
        @click="goToHomePage"
      >
        {{ $t('button_back') }}
      </f7-button>
    </f7-block-footer>
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxSearchPanel,
  DxExport,
  DxColumnFixing,
  DxHeaderFilter,
  DxPager,
  DxSelection,
} from 'devextreme-vue/data-grid';
import { mapState } from 'vuex';
import { DxScrollView } from 'devextreme-vue/scroll-view';
import DxButton from 'devextreme-vue/button';
import { DEVICE_PLATFORM, NUMBER_OF_DECIMALS, TO_FIXED_DECIMALS_IN_TABLES } from '../../../js/constants';

export default {
  name: 'RecommendationData',
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxSearchPanel,
    DxExport,
    DxColumnFixing,
    DxHeaderFilter,
    DxPager,
    DxSelection,
    DxScrollView,
    DxButton,
  },
  data() {
    return {
      data: [],
      graphsData: [],
      NUMBER_OF_DECIMALS,
      TO_FIXED_DECIMALS_IN_TABLES,
      showScroll: true,
      DEVICE_PLATFORM,
    };
  },
  computed: {
    showColumnByCrop() {
      if (this.resultProject && this.resultProject.cultive) {
        switch (this.resultProject.cultive.crop_name) {
          case 'Sandía':
          case 'Berenjena':
          case 'Calabacín':
            return false;
          default:
            return true;
        }
      }
      return true;
    },
    ...mapState('authentication', [
      'selection',
    ]),
    ...mapState('Result', [
      'resultProject',
    ]),
    selectionClass() {
      return this.selection === 'GreenHouse' ? 'dx-btn-success color-orange' : 'dx-btn-success open-air';
    },
  },
  beforeMount() {
    this.$f7.preloader.show();
    this.graphsData = this.resultProject.result.soil_needs_N.map((soilNeedsN, index) => ({
      ddt: index,
      date: this.resultProject.result.dates[index],
      week: Math.trunc(index / 7) + 1,
      soil_needs_N: this.resultProject.result.soil_needs_N[index],
      soil_needs_Ca: this.resultProject.result.soil_needs_Ca[index],
      soil_needs_K: this.resultProject.result.soil_needs_K[index],
      soil_needs_Mg: this.resultProject.result.soil_needs_Mg[index],
      soil_needs_P: this.resultProject.result.soil_needs_P[index],
      soil_needs_N_fixed: Number(this.resultProject.result.soil_needs_N[index]
        .toFixed(this.NUMBER_OF_DECIMALS)),
      soil_needs_Ca_fixed: Number(this.resultProject.result.soil_needs_Ca[index]
        .toFixed(this.NUMBER_OF_DECIMALS)),
      soil_needs_K_fixed: Number(this.resultProject.result.soil_needs_K[index]
        .toFixed(this.NUMBER_OF_DECIMALS)),
      soil_needs_Mg_fixed: Number(this.resultProject.result.soil_needs_Mg[index]
        .toFixed(this.NUMBER_OF_DECIMALS)),
      soil_needs_P_fixed: Number(this.resultProject.result.soil_needs_P[index]
        .toFixed(this.NUMBER_OF_DECIMALS)),
    }));

    const prepareData = [];

    if (this.resultProject.result
        && this.resultProject.result.soil_nutrien_recomendation_1weeks) {
      this.resultProject.result.soil_nutrien_recomendation_1weeks
        .initial_day.forEach((item, index) => {
          prepareData.push(
            {
              ddt: index + 1,
              week: index + 1,
              date: `${item} al ${this.resultProject.result.soil_nutrien_recomendation_1weeks.last_day[index]}`,
              soil_needs_N: Number(this.resultProject.result.soil_nutrien_recomendation_1weeks
                .nitrogen[index].toFixed(this.NUMBER_OF_DECIMALS)),
              soil_needs_Ca: Number(this.resultProject.result.soil_nutrien_recomendation_1weeks
                .calcium[index].toFixed(this.NUMBER_OF_DECIMALS)),
              soil_needs_K: Number(this.resultProject.result.soil_nutrien_recomendation_1weeks
                .potassium[index].toFixed(this.NUMBER_OF_DECIMALS)),
              soil_needs_Mg: Number(this.resultProject.result.soil_nutrien_recomendation_1weeks
                .magnesium[index].toFixed(this.NUMBER_OF_DECIMALS)),
              soil_needs_P: Number(this.resultProject.result.soil_nutrien_recomendation_1weeks
                .phosphorus[index].toFixed(this.NUMBER_OF_DECIMALS)),
            },
          );
        });
    }

    this.data = prepareData;
    this.$f7.preloader.hide();
  },
  methods: {
    goToHomePage() {
      this.$f7.views.main.router.navigate('/tabs-result-greenhouse/', { reloadCurrent: true });
    },
    showAll() {
      this.showScroll = !this.showScroll;
    },
    onFileSaving(e) {
      if (DEVICE_PLATFORM === 'android') {
        const { name } = this.resultProject;
        cordova.plugins.saveDialog.saveFile(e.data, `${this.resultProject.name} - Abonado - RECOMENDACIONES.xlsx`).then((uri) => {
          console.info('The file has been successfully saved to', uri);
        }).catch((reason) => {
          console.warn(reason);
        });
      }
    },
  },
};
</script>
<style
  lang="scss"
  scoped
>
@import "../../../css/mixins";
.boton-greenHouse {
  background: #FF7F26;
  height: 30px;
  width: 100px;
  margin-top: 60px;
  text-align: center;
}
.boton-openAir {
  background: #51A411;
  height: 30px;
  width: 100px;
  margin-top: 60px;
  text-align: center;
}
.content-checkbox {
  padding-top: 50px;
  padding-left: 40px;
}
.content-devx {
  height: 500px !important;
}
.content-note {
  margin: 0 1rem 2rem;
  max-width: 1080px;
  text-align: center !important;
  @include md {
    margin: 2rem;
    text-align: center !important;
  }
}
.note {
  font-family: 'Roboto';
  font-style: normal;
  line-height: normal;
  color: steelblue;
  font-size: small;
  @include md {
    font-size: large;
    line-height: 28px;
  }
}
</style>
